query GetUsers(
  $page: Int
  $limit: Int
  $search: String
  $searchType: UserSearchEnum
  $sortBy: String
) {
  users(
    page: $page
    limit: $limit
    search: $search
    searchType: $searchType
    sortBy: $sortBy
  ) {
    collection {
      id
      firstName
      surname
      name
      email
      hasContactLink
      signingCompleted
      companyLogoUrl
      avatarUrl
      quote
      bio
      salesforceId
      memberPageVisibility
      admin
      isMemberAppUser
      isGranteePortalUser
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
